import { Box, Typography } from "@mui/material";
import { memo } from "react";

function Page404() {
  return (
    <Box>
      <Typography variant="body1">Page404</Typography>
    </Box>
  );
}

export default memo(Page404);
